import React from 'react';
import { Route } from 'react-router-dom';
import async from '@xanadu/ui-shared/components/asyncComponent';

import GlobalBannerPortal from '@xanadu/ui-shared/components/GlobalBannerPortal';

const AsyncStaticPage = async(() =>
  import('@xanadu/ui-shared/components/StaticPage').then(module => module.default)
);

export default function () {
  return (
    <React.Fragment>
      <GlobalBannerPortal bigger />
      <Route
        path="/page/:pageCategory/:urlTitle?"
        component={({ match: { params } }) => (<AsyncStaticPage {...params} />)}
      />
    </React.Fragment>
  );
}
